import type { Cargo } from "@/vendor/types/Cargo";
import { init } from "@plausible-analytics/tracker";

export function initPlausible() {
  init({
    domain: "alertmouse.com",

    // By default Plausible disables itself in dev. Uncomment this to test
    // on localhost.
    // captureOnLocalhost: true,

    customProperties: function (_eventName) {
      // Because inertia hasn't finished processing the page yet, we need to dig
      // straight into history.state rather than relying on usePage() or
      // Current.
      //
      // This should never actually be undefined, but be extra cautious here.
      const cargo = history?.state?.page?.props?.cargo as Cargo | undefined;
      const loggedIn = !!cargo?.user;

      return {
        loggedIn: loggedIn.toString(),
      };
    },
  });
}
